import React from 'react';

const PoweredByAlgolia = () => (
    <div className="powered-by-algolia-container">
        <span>Search by</span>
        <a href="https://algolia.com" target="_blank" title="Algolia" rel="noreferrer noopener">
            <img className="algolia-logo" src="/assets/images/algolia-logo.png" alt="Algolia" />
        </a>
    </div>
);

export default PoweredByAlgolia;
